import { ADMIN_ICONS } from '@shared/icons/admin-icons';

export interface NavItem {
  label: string;
  path: string;
  icon: string;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    title: 'nav.general',
    items: [{ label: 'nav.dashboard', path: '/dashboard', icon: ADMIN_ICONS.dashboard }],
  },
  {
    title: 'nav.catalog',
    items: [
      { label: 'nav.peeks', path: '/items', icon: ADMIN_ICONS.items },
      { label: 'nav.lives', path: '/lives', icon: ADMIN_ICONS.lives },
      { label: 'nav.categories', path: '/categories', icon: ADMIN_ICONS.categories },
      {
        label: 'nav.productRequests',
        path: '/product-requests',
        icon: ADMIN_ICONS.productRequests,
      },
    ],
  },
  {
    title: 'nav.reference',
    items: [{ label: 'nav.referenceTcg', path: '/tcg-reference', icon: ADMIN_ICONS.tcgReference }],
  },
  {
    title: 'nav.commerce',
    items: [
      { label: 'nav.orders', path: '/orders', icon: ADMIN_ICONS.orders },
      { label: 'nav.discounts', path: '/discounts', icon: ADMIN_ICONS.discounts },
      {
        label: 'nav.referralCampaigns',
        path: '/referral-campaigns',
        icon: ADMIN_ICONS.referralCampaigns,
      },
    ],
  },
  {
    title: 'nav.users',
    items: [
      { label: 'nav.users', path: '/users', icon: ADMIN_ICONS.users },
      { label: 'nav.shops', path: '/shops', icon: ADMIN_ICONS.shops },
      { label: 'nav.sellerRequests', path: '/seller-requests', icon: ADMIN_ICONS.sellerRequests },
      { label: 'nav.buyerStrikes', path: '/buyer-strikes', icon: ADMIN_ICONS.buyerStrikes },
    ],
  },
  {
    title: 'nav.finance',
    items: [
      { label: 'nav.platformWallet', path: '/finance', icon: ADMIN_ICONS.reconciliation },
      { label: 'nav.sellerDebts', path: '/seller-debts', icon: ADMIN_ICONS.sellerDebts },
      {
        label: 'nav.pdpSubmissionReviews',
        path: '/orders/pdp-reviews',
        icon: ADMIN_ICONS.missingInvoices,
      },
      {
        label: 'nav.missingInvoices',
        path: '/missing-invoices',
        icon: ADMIN_ICONS.missingInvoices,
      },
      { label: 'nav.reconciliation', path: '/reconciliation', icon: ADMIN_ICONS.reconciliation },
    ],
  },
  {
    title: 'nav.moderation',
    items: [
      { label: 'nav.reports', path: '/reports', icon: ADMIN_ICONS.reports },
      { label: 'nav.reviews', path: '/reviews', icon: ADMIN_ICONS.reviews },
      { label: 'nav.messaging', path: '/messages', icon: ADMIN_ICONS.conversations },
    ],
  },
  {
    title: 'nav.support',
    items: [{ label: 'nav.supportTickets', path: '/support', icon: ADMIN_ICONS.emails }],
  },
  {
    title: 'nav.configuration',
    items: [
      {
        label: 'nav.deliveryCarriers',
        path: '/delivery-carriers',
        icon: ADMIN_ICONS.deliveryCarriers,
      },
      { label: 'nav.emails', path: '/emails', icon: ADMIN_ICONS.emails },
      {
        label: 'nav.notificationDeliveries',
        path: '/notification-deliveries',
        icon: ADMIN_ICONS.emails,
      },
      { label: 'nav.search', path: '/search', icon: ADMIN_ICONS.search },
    ],
  },
  {
    title: 'nav.system',
    items: [
      { label: 'nav.launchStatus', path: '/launch-status', icon: ADMIN_ICONS.launchStatus },
      { label: 'nav.queues', path: '/queues', icon: ADMIN_ICONS.queues },
      { label: 'nav.adminActions', path: '/admin-actions', icon: ADMIN_ICONS.adminActions },
      { label: 'nav.nodes', path: '/nodes', icon: ADMIN_ICONS.nodes },
      { label: 'nav.infrastructure', path: '/infra', icon: ADMIN_ICONS.infrastructure },
      { label: 'nav.systemHealth', path: '/system', icon: ADMIN_ICONS.systemHealth },
    ],
  },
  {
    title: 'nav.personal',
    items: [{ label: 'nav.settings', path: '/settings', icon: ADMIN_ICONS.settings }],
  },
];
